import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { DoBoxSortConfig } from '../../components/DoBoxFilters/types';
import { DoBoxViewMode } from '../../pages/private/DoBox/constants/doBoxViewMode';
import { ZustandStores } from '../utils';
import { createIndexedDBStorage } from '../utils/indexedDBAdapter';

export interface StoredRecentMember {
  id: string;
  lastUsedAt: number;
}

interface DoBoxPreferencesState {
  recentMembers: StoredRecentMember[];
  sortConfig: DoBoxSortConfig | null;
  viewModeByTaskGroupId: Record<string, DoBoxViewMode>;
  isDetailsDialogMaximized: boolean;
}

interface DoBoxPreferencesActions {
  setRecentMembers: (members: StoredRecentMember[]) => void;
  setSortConfig: (config: DoBoxSortConfig) => void;
  setViewMode: (taskGroupId: string, mode: DoBoxViewMode) => void;
  setViewModeByTaskGroupId: (map: Record<string, DoBoxViewMode>) => void;
  setIsDetailsDialogMaximized: (value: boolean) => void;
  reset: () => void;
}

type DoBoxPreferencesStore = DoBoxPreferencesState & DoBoxPreferencesActions;

const INITIAL_STATE: DoBoxPreferencesState = {
  recentMembers: [],
  sortConfig: null,
  viewModeByTaskGroupId: {},
  isDetailsDialogMaximized: false,
};

export const useDoBoxPreferencesStore = create<DoBoxPreferencesStore>()(
  persist(
    (set) => ({
      ...INITIAL_STATE,
      setRecentMembers: (members) => set({ recentMembers: members }),
      setSortConfig: (config) => set({ sortConfig: config }),
      setViewMode: (taskGroupId, mode) =>
        set((state) => ({
          viewModeByTaskGroupId: {
            ...state.viewModeByTaskGroupId,
            [taskGroupId]: mode,
          },
        })),
      setViewModeByTaskGroupId: (map) => set({ viewModeByTaskGroupId: map }),
      setIsDetailsDialogMaximized: (value) =>
        set({ isDetailsDialogMaximized: value }),
      reset: () => set(INITIAL_STATE),
    }),
    {
      name: ZustandStores.DOBOX_PREFERENCES,
      storage: createJSONStorage(() => createIndexedDBStorage()),
    },
  ),
);
